import {PageView} from "./PageView.js";
import {InviteLayout} from "../components/layout/InviteLayout.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {Header} from "../components/Header.js";
import {getEmail, getUser} from "../store.js";
import {findInviterList} from "../../../apiCall/signup/index.js";
import {InviterList} from "../components/InviterList.js";
import {IconButton} from "../components/button/IconButton.js";

export class CompanyInviteUserView extends PageView {

    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        this.$props.InviteLayout = new InviteLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText
        });
    }

    async renderComponents() {
        if(!this.$props.InviteLayout) {
            return;
        }

        new Header(this.$props.InviteLayout.getHeaderLayer(), {
            isShowLoginBtn: false,
            isShowPrevBtn: true
        });

        new IconButton( this.$props.InviteLayout.getCorpButtonLayer(), {
            isAppend : true,
            id: "create",
            icon : "plus",
            buttonText : `${i18next.t(login.createNewCompany)}`,
            clickFunc : () => {
                SignUpViewChanger.loadCompanyInfoInputView()
            }
        })

        new IconButton( this.$props.InviteLayout.getCorpButtonLayer(), {
            isAppend : true,
            id: "join",
            icon : "clip",
            buttonText : `${i18next.t(login.joinCompany)}`,
            clickFunc : () => {
                SignUpViewChanger.loadSearchCompanyBySubDomain()
            }
        })

        this.renderCompanyInviteComponent().then();
    }


    async renderCompanyInviteComponent() {
        const inviterList = await getUser().getInviterList();
        if(inviterList.length === 0) {
            return;
        }

        this.$props.InviteLayout.showInviteUlLayer();
        new InviterList(this.$props.InviteLayout.getInviteUlLayer(), {
            isAppend : true,
            inviterList,
            moveCompanyInfoPage: () => {
                SignUpViewChanger.loadCompanyInfoView(true);
            }
        })
    }

    getSectionId() {
        return `companyInviteSection`
    }

    getNextButtonText() {
        return i18next.t(login.createCompany);
    }
}